import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const FIBERZETAPOTENTIALANALYZER = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,        // ✅ slower transition (2 seconds)
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
  };

  const images = [
    'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpulpinstrument%2Fimg%2F1772781895065_online.png?alt=media&token=786efff1-275c-40ef-94b6-7ee9a4424293',
    'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpulpinstrument%2Fimg%2F1772781895065_online.png?alt=media&token=786efff1-275c-40ef-94b6-7ee9a4424293'
  ];

  return (
    <Layout>
      <div className="bread">
        <ul className="collapsed">
          <li><a href="/">Home</a></li>
          <li><a href="/paperTesting">Paper Testing</a></li>
        </ul>
      </div>
      <div className="container">
        <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
          <h1>Online Fiber Zeta Potential Analyzer</h1>
        </div>
      </div>
      <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-8">
              <div className="portfolio-details-slider swiper">
                <Slider {...settings}>
                  {images.map((src, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="img" style={{ alignItems: 'center' }}>
                        <img src={src} alt="" className="responsive" />
                      </div>
                    </div>
                  ))}
                </Slider>
                <div className="swiper-pagination"></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                <h3 className='pageheading'>Online Fiber Zeta Potential Analyzer </h3>
                <div className='descriptionHead' style={{ textAlign: 'justify' }}>
                  <p>
                    The new Online FPO - Fiber Potential Analyzer uses the established streaming current potential
                    measuring principle.  FPA delivers accurate, fast & reliable results. The Emtec FPO gives the
                    possibility of control and optimization of the dosage of chemical additives during the paper
                    production in the followings.
                  </p>

                  <ul style={{ paddingLeft: "20px" }}>
                    <li>Dosage of starch</li>
                    <li>Wet strength agent / dry strength agent</li>
                    <li>Drainage aid</li>
                    <li>Other chemical additives</li>
                  </ul>

                  <a
                    href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Online (FPO)"
                    style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                  >
                    More Info
                  </a>
                </div>
              </div>
              <div className="portfolio-description"></div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default FIBERZETAPOTENTIALANALYZER